// Singleton Socket.io client. Reuses one connection across the whole app so
// reconnection state is consistent and events aren't double-bound.
//
// Sprint 11b — multi-server: when the active server changes, the old socket
// is torn down and a new one is created pointing at the new baseUrl.

import { io, Socket } from 'socket.io-client';
import { getActiveBaseUrl } from '../stores/servers.store';

let socket: Socket | null = null;
let socketBaseUrl: string | null = null;

function createSocket(baseUrl: string): Socket {
  const opts: Parameters<typeof io>[1] = {
    withCredentials: true,
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 60_000,
    randomizationFactor: 0,
    reconnectionAttempts: Infinity,
    autoConnect: true,
    transports: ['websocket', 'polling'],
  };
  // When baseUrl is empty (same-origin), Socket.io auto-detects. When set,
  // we pass the explicit URL so the client connects cross-origin.
  if (baseUrl) {
    return io(baseUrl, opts);
  }
  return io(opts);
}

// Cuentas personales: si a esta sesión la cierran (Pau la echa, o se desactiva la cuenta), el servidor corta la
// conexión en el acto; aquí se lleva a la pantalla de entrada en vez de dejar la oficina congelada.
function alPerderSesion(): void {
  const ruta = window.location.pathname;
  if (ruta.startsWith('/login') || ruta.startsWith('/alta')) return;
  window.location.assign('/login');
}

function vigilarSesion(s: Socket): Socket {
  s.on('sesion:cerrada', alPerderSesion);
  s.on('connect_error', (err: Error) => {
    if (err.message === 'UNAUTHENTICATED') alPerderSesion();
  });
  return s;
}

export function getSocket(): Socket {
  const base = getActiveBaseUrl();
  // If the target server changed, tear down the old socket and rebuild.
  if (socket && socketBaseUrl !== base) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  if (!socket) {
    socket = vigilarSesion(createSocket(base));
    socketBaseUrl = base;
  }
  return socket;
}
